// homeReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchCriteria: null,
  loading4Home: false,
  userListItem: null,
  verseReadLogList4Book: [], // list of {book, chapter} where book values of all are the same and they are all read, i.e. only keep which chapter has been read in a specific book, e.g. [{1,1}, {1,3}, {1, 17}]
  searchTabNumber: null,
  confirmedTabNumber: -1,
  bookChapter: { book: 0, chapter: 0 },
  bookList: [],
  open2: false,
  // open4: false,
  viewArea: null,
  circularProgressText: '',
  debug: true,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setCircularProgressText(state, action) {
      state.circularProgressText = action.payload;
    },
    setSearchCriteria(state, action) {
      state.searchCriteria = action.payload;
    },
    setLoading4Home(state, action) {
      state.loading4Home = action.payload;
    },
    setUserListItem(state, action) {
      state.userListItem = action.payload;
    },
    setVerseReadLogList4Book(state, action) {
      state.verseReadLogList4Book = action.payload;
    },
    setSearchTabNumber(state, action) {
      state.searchTabNumber = action.payload;
    },
    setConfirmedTabNumber(state, action) {
      state.confirmedTabNumber = action.payload;
    },
    setBookChapter(state, action) {
      state.bookChapter = action.payload;
    },
    setBookList(state, action) {
      state.bookList = action.payload;
    },
    setOpen2(state, action) {
      state.open2 = action.payload;
    },
    // setOpen4(state, action) {
    //   state.open4 = action.payload;
    // },
    setViewArea(state, action) {
      state.viewArea = action.payload;
    },
    reset4Home() {
      return initialState;
    },
  },
});

export const { setCircularProgressText, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setConfirmedTabNumber, setBookChapter, setBookList, setOpen2, setViewArea, reset4Home } = homeSlice.actions;
export default homeSlice.reducer;
// import { API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

// const initialState = {
//   searchCriteria: null,
//   loading4Home: false,
//   userListItem: null,
//   verseReadLogList: [], // list of {book, chapter} where book values of all are the same, i.e. only keep which chapter has been read in a specific book, e.g. [{1,1}, {1,3}, {1, 17}]
//   searchTabNumber: null,
//   confirmedTabNumber: -1,
//   // confirmedBookChapterList: [
//   //   { id: 0, book: 0, chapter: 0, verseTotal: 0, showLeftArrow: true, showRightArrow: true },
//   //   { id: 1, book: 0, chapter: 0, verseTotal: 0, showLeftArrow: true, showRightArrow: true },
//   //   { id: 2, book: 0, chapter: 0, verseTotal: 0, showLeftArrow: true, showRightArrow: true },
//   //   { id: 3, book: 0, chapter: 0, verseTotal: 0, showLeftArrow: true, showRightArrow: true }
//   // ],
//   //fontSize: 0,
//   bookChapter: { book: 0, chapter: 0 },
//   bookList: [],
//   open2: false,
//   open4: false,
//   viewArea: null,
//   circularProgressText: '',
//   debug: true,
//   //errorResponse: {},
// };

// export default function homeReducer(state = initialState, action) {
//   switch (action.type) {
//     // case 'setErrorResponse':
//     //   return {
//     //     ...state,
//     //     errorResponse: action.payload,
//     //   };      
//     case 'setCircularProgressText':
//       return {
//         ...state,
//         circularProgressText: action.payload,
//       };    
//     case 'setSearchCriteria':
//       return {
//         ...state,
//         searchCriteria: action.payload,
//       };
//     case 'setLoading4Home':
//       return {
//         ...state,
//         loading4Home: action.payload,
//       };    
  
//     case 'setUserListItem':
//       return {
//         ...state,
//         userListItem: action.payload,
//       };        
//     case 'setVerseReadLogList4Book':
//       return {
//         ...state,
//         verseReadLogList: action.payload,
//       };   
//     case 'setSearchTabNumber':
//       return {
//         ...state,
//         searchTabNumber: action.payload,
//       };    
//     case 'setConfirmedTabNumber':
//       return {
//         ...state,
//         confirmedTabNumber: action.payload,
//       };     
//     // case 'setConfirmedBookChapterList':
//     //   return {
//     //     ...state,
//     //     confirmedBookChapterList: action.payload,
//     //   };
//     // case 'setFontSize':
//     //   return {
//     //     ...state,
//     //     fontSize: action.payload,
//     //   };
//     case 'setBookChapter':
//       return {
//         ...state,
//         bookChapter: action.payload,
//       };
//     case 'setBookList':
//       return {
//         ...state,
//         bookList: action.payload,
//       };    
//     // case 'setSearchVisible':
//     //   return {
//     //     ...state,
//     //     searchVisible: action.payload,
//     //   };   
//     //   //noteVisible
//     // case 'setNoteVisible':
//     //   return {
//     //     ...state,
//     //     noteVisible: action.payload,
//     //   };   
//     case 'setOpen2':
//       return {
//         ...state,
//         open2: action.payload,
//       };       
//     case 'setOpen4':
//       return {
//         ...state,
//         open4: action.payload,
//       };        
//     case 'setViewArea':
//       return {
//         ...state,
//         viewArea: action.payload,
//       };              
//     case 'reset4Home':
//       return initialState;                 
//     default:
//       return state;
//   }
// }
// //errorResponse

// // export const setErrorResponse = (e) => ({
// //   type: 'setErrorResponse',
// //   payload: e,
// // });

// export const setCircularProgressText = (e) => ({
//   type: 'setCircularProgressText',
//   payload: e,
// });

// export const setSearchCriteria = (e) => ({
//   type: 'setSearchCriteria',
//   payload: e,
// });

// export const setLoading4Home = (e) => ({
//   type: 'setLoading4Home',
//   payload: e,
// });

// export const setUserListItem = (e) => ({
//   type: 'setUserListItem',
//   payload: e,
// });

// export const setVerseReadLogList4Book = (e) => ({
//   type: 'setVerseReadLogList4Book',
//   payload: e,
// });

// export const setSearchTabNumber = (e) => ({
//   type: 'setSearchTabNumber',
//   payload: e,
// });

// export const setConfirmedTabNumber = (e) => ({
//   type: 'setConfirmedTabNumber',
//   payload: e,
// });

// // export const setConfirmedBookChapterList = (e) => ({
// //   type: 'setConfirmedBookChapterList',
// //   payload: e,
// // });

// // export const setFontSize = (e) => ({
// //   type: 'setFontSize',
// //   payload: e,
// // });

// export const setBookChapter = (e) => ({
//   type: 'setBookChapter',
//   payload: e,
// });

// export const setBookList = (e) => ({
//   type: 'setBookList',
//   payload: e,
// });

// // export const setSearchVisible = (e) => ({
// //   type: 'setSearchVisible',
// //   payload: e,
// // });

// // export const setNoteVisible = (e) => ({
// //   type: 'setNoteVisible',
// //   payload: e,
// // });

// export const reset4Home  = (e) => ({
//   type: 'reset4Home',
//   payload: e,
// });

// export const setOpen2  = (e) => ({
//   type: 'setOpen2',
//   payload: e,
// });

// export const setOpen4  = (e) => ({
//   type: 'setOpen4',
//   payload: e,
// });

// export const setViewArea  = (e) => ({
//   type: 'setViewArea',
//   payload: e,
// });